/* NEX product page: remember last viewed, sticky add to bag (with size/color), buy now, related + best sellers of the same kind */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  function post(u, b) {
    return fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  var pdp = document.querySelector('[data-product]');
  if (!pdp) return;
  var pid = pdp.getAttribute('data-product-id');
  try { if (pid) localStorage.setItem('nex:last', pid); } catch (e) {}
  var form = $('[data-product-form]', pdp), addBtn = $('[data-add]', pdp), price = $('[data-price]', pdp);
  var bar = $('[data-satc]', pdp), buy = $('[data-buy-now]', pdp);

  /* sticky bar options: chips mirror the main size/color choices (colors in their own color) */
  var chips = [];
  function syncChips() {
    chips.forEach(function (c) { c.b.classList.toggle('is-on', c.i.checked); c.b.disabled = c.i.disabled; });
  }
  if (bar && form) {
    var sets = form.querySelectorAll('.opt'), inner = $('.satc__in', bar);
    if (sets.length && inner) {
      var wrap = document.createElement('div'); wrap.className = 'satc__opts';
      [].forEach.call(sets, function (fs) {
        var row = document.createElement('div'); row.className = 'satc__row';
        var lg = fs.querySelector('legend'); if (lg) { var l = document.createElement('span'); l.className = 'satc__lg'; l.textContent = lg.textContent; row.appendChild(l); }
        [].forEach.call(fs.querySelectorAll('label.opt__chip'), function (lab) {
          var i = lab.querySelector('input'), b = document.createElement('button');
          b.type = 'button'; b.className = 'satc__chip' + (lab.classList.contains('opt__chip--swatch') ? ' satc__chip--sw' : '');
          var st = lab.getAttribute('style'); if (st) b.setAttribute('style', st);
          b.textContent = (lab.querySelector('span') || lab).textContent.trim(); b.title = b.textContent;
          b.addEventListener('click', function () { if (!i.checked) i.click(); syncChips(); });
          row.appendChild(b); chips.push({ i: i, b: b });
        });
        wrap.appendChild(row);
      });
      inner.insertBefore(wrap, inner.firstChild);
      form.addEventListener('change', function () { syncChips(); setTimeout(syncChips, 60); });
      syncChips();
    }
  }

  /* keep the sticky bar and Buy now in step with the main button (price, sold out); only write when something changed */
  function sync() {
    if (!addBtn) return;
    var bp = bar && $('[data-satc-price]', bar), bb = bar && $('[data-satc-add]', bar);
    if (bp && price && bp.innerHTML !== price.innerHTML) bp.innerHTML = price.innerHTML;
    if (bb) { if (bb.disabled !== addBtn.disabled) bb.disabled = addBtn.disabled; if (bb.textContent !== addBtn.textContent) bb.textContent = addBtn.textContent; }
    if (buy && buy.disabled !== addBtn.disabled) buy.disabled = addBtn.disabled;
    syncChips();
  }
  if (addBtn && 'MutationObserver' in window) {
    var mo = new MutationObserver(sync);
    mo.observe(addBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
    if (price) mo.observe(price, { childList: true, characterData: true, subtree: true });
  }
  if (bar && addBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var off = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      bar.hidden = false; bar.classList.toggle('is-on', off);
    }).observe(addBtn);
    $('[data-satc-add]', bar).addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else addBtn.click(); });
  }
  if (buy) buy.addEventListener('click', function () {
    var id = $('[data-variant-id]', pdp).value, qn = +($('[data-qty]', pdp) || {}).value || 1;
    buy.disabled = true;
    post('/cart/add.js', { items: [{ id: +id, quantity: qn }] }).then(function () { location.href = '/checkout'; })
      .catch(function (er) { buy.disabled = false; alert((er && er.description) || 'Could not continue'); });
  });

  /* related: Shopify's recommendation engine; best sellers: Shopify's sales ranking of the same kind (hoodies -> hoodies, caps -> caps) */
  var mount = $('[data-recs]', pdp);
  var KIND = function (t) {
    t = (t || '').toLowerCase();
    if (t === 'hoodie') return ['hoodies', 'hoodies'];
    if (t === 'cap' || t === 'caps') return ['vintage-washed-cap', 'hats'];
    if (/cropped/.test(t)) return ['big-crops', 'crop tees'];
    if (/t-?shirt/.test(t)) return ['summer-tees', 'summer tees'];
    return ['all', ''];
  };
  function best(host) {
    var hm = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!hm) return;
    fetch('/products/' + hm[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var k = KIND(p.type);
      return fetch('/collections/' + k[0] + '?sort_by=best-selling&section_id=best-sellers').then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var cards = [].slice.call(d.querySelectorAll('.card')).filter(function (c) { return (c.getAttribute('href') || '').indexOf('/products/' + hm[1]) < 0; }).slice(0, 4);
        if (!cards.length) return;
        var t = document.createElement('h2'); t.className = 'recs__title'; t.textContent = k[1] ? 'Best selling ' + k[1] : 'Best sellers';
        var g = document.createElement('div'); g.className = 'recs__grid';
        cards.forEach(function (c) { c.classList.add('is-in'); g.appendChild(c); });
        host.appendChild(t); host.appendChild(g);
      });
    }).catch(function () {});
  }
  var bestHost = document.createElement('div'); bestHost.className = 'wrap pdp-recs pdp-best';
  if (mount && mount.parentNode) mount.parentNode.insertBefore(bestHost, mount.nextSibling); else pdp.appendChild(bestHost);
  if (mount) {
    var load = function () {
      fetch(mount.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var inner = d.querySelector('[data-recs-inner]');
        if (inner && inner.innerHTML.trim()) { mount.innerHTML = inner.innerHTML; [].forEach.call(mount.querySelectorAll('.reveal'), function (x) { x.classList.add('is-in'); }); }
      });
    };
    if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' }); io.observe(mount); } else load();
  }
  if ('IntersectionObserver' in window) { var io2 = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io2.disconnect(); best(bestHost); } }, { rootMargin: '500px' }); io2.observe(bestHost); } else best(bestHost);
})();